// expandable.js
(() => {
    const expandedClass = 'expandable_expanded'
    document.querySelectorAll('.expandable').forEach(expandable => {
        const toggler = expandable.querySelector('.expandable__toggler')
        // data-js-disabled
        const disabled = expandable.dataset.jsDisabled

        console.log(typeof disabled)

        if (disabled === 'true') return


        toggler.addEventListener('click', () => {
            expandable.classList.toggle(expandedClass)
        })
    })
})();